import { SIMULATE_LINE } from 'domain/entities/SimulateDescEntity';

export const descView = (data: any[]) => {
    const DESC: SIMULATE_LINE[] = [
        {
            items: [
                {
                    colSpan: 12,
                    titleSpan: 4,
                    title: '毎月の収支',
                    value: data[0].center,
                    prefix: '円',
                },
                {
                    colSpan: 12,
                    titleSpan: 4,
                    title: '年間の収支',
                    value: data[0].right,
                    prefix: '円',
                },
            ],
        },
        {
            items: [
                {
                    colSpan: 12,
                    titleSpan: 4,
                    title: 'ローン金額',
                    value: data[1].center,
                    prefix: '円',
                },
                {
                    colSpan: 12,
                    titleSpan: 5,
                    title: '賃貸管理手数料',
                    value: data[1].right,
                    prefix: '円',
                },
            ],
        },
        {
            items: [
                {
                    colSpan: 12,
                    titleSpan: 5,
                    title: '月々のお支払い',
                    value: data[2].center,
                    prefix: '円',
                },
                {
                    colSpan: 12,
                    titleSpan: 4,
                    title: '管理費等',
                    value: data[2].right,
                    prefix: '円',
                },
            ],
        },
        {
            items: [
                {
                    colSpan: 12,
                    titleSpan: 4,
                    title: '家賃収入',
                    value: data[3].center,
                    prefix: '円',
                },
                {
                    colSpan: 12,
                    titleSpan: 4,
                    title: '共益費収入',
                    value: data[3].right,
                    prefix: '円',
                },
            ],
        },
    ];

    return DESC;
};
